import React from "react";
import UnitGrid from "./UnitGrid";

const UnitPage = () => {
  return (
    <div className="c-main">
      <div className="c-content">
        <UnitGrid />
      </div>
    </div>
  );
};
export default UnitPage;
